import styled from '@emotion/styled';

export const Notification = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 1.19;
  letter-spacing: 0.03em;
`;
